import { EarningsValue } from '@api';
import { WithNAFallback } from '@design/components/table';
import { formatPercentage } from '@helpers';
import {
  formatCurrencyValue,
  formatSurpriseValue,
} from '@terminal/widgets/earnings/utils/utils';
import clsx from 'clsx';

import styles from './MetricValue.module.scss';

export interface MetricValueProps {
  data: Partial<EarningsValue>;
  currencySymbol: string;
}

export const MetricValue = ({ data, currencySymbol }: MetricValueProps) => {
  const hasValue = data.value !== undefined;

  if (!hasValue) {
    return <WithNAFallback check={false} value={null} />;
  }

  return (
    <>
      <span>{formatCurrencyValue(data.value, currencySymbol)}</span>
      {data.surprise !== undefined ? (
        <span
          className={clsx(styles.surprise, {
            [styles.bullish]: data.surprise > 0,
            [styles.bearish]: data.surprise < 0,
          })}
        >
          {formatSurpriseValue(data.surprise, currencySymbol)}
          {data.surprise_percentage !== undefined &&
            ` (${formatPercentage(data.surprise_percentage, {
              suffix: '%',
              addPlus: true,
              useOriginalValue: true,
            })})`}
        </span>
      ) : null}
    </>
  );
};
